export interface IOrderSkuInfo {
  /**
   * sku名称
   */
  skuName: string;
  /**
   * 子订单金额
   */
  orderItemAmount: number;
  /**
   * 价格币种id
   */
  skuPriceCurrencyId: number;
  /**
   * sku主图图片
   */
  skuImageUrl: string;
  /**
   * sku详情
   */
  skuDetailUrl: string;
  /**
   * sku规格值
   */
  skuSpecValues: string;
  /**
   * sku数量
   */
  skuCount: number;
}

export interface ICommmentInfo {
  /**
   * 评价ID
   */
  commentId: number;
  /**
   * 评价时间【适用于已评】
   */
  commentTime: number;
  /**
   * 商品评分
   */
  goodsGrade: number;
  /**
   * 文本内容
   */
  content: string;
  /**
   * 图片列表
   */
  images: undefined;
  /**
   * 图片位置索引
   */
  imageIdxs: undefined;
  /**
   * 是否匿名
   */
  anonymous: boolean;
  /**
   * 是否本人
   */
  self: boolean;
  /**
   * 回复ID
   */
  replyId: number;
  /**
   * 主评回复内容
   */
  replyContent: string;
}

export interface IEvaluation {
  /**
   * 昵称
   */
  nickName: string;
  /**
   * 用户头像/匿名随机头像
   */
  avatar: string;
  // sku 信息
  orderSkuInfo: IOrderSkuInfo;
  commentInfo: ICommmentInfo;
}

// 评价组件的使用场景: 评价页面， 商详模块
export enum EvaluationItemType {
  EvaluationPage = 1,
  DetailModule,
}

// 评价组件的 Props
export interface EvaluationItemProps {
  type?: EvaluationItemType;
  wrapClassName?: string;
  isLast?: boolean;
  clickImg?: (commentId: number, index: number) => void;
  detail: IEvaluation;
}
